import { useFormValues } from '../core';
// Imported by path, not through the utils barrel, to keep hooks and utils acyclic.
import { findFieldDeclarations } from '../utils/findFieldDeclarations';
import type { ActiveFieldDeclaration } from '../utils/findFieldDeclarations';
import type { FormField, FormInitialValues } from '../typings';

/**
 * The declarations the group's fields currently trigger. Re-derives on every
 * value change and is deliberately not gated on `touched`, so a saved form
 * reopened for editing shows them on mount.
 */
export const useFieldDeclarations = (
  fields: FormField[] | undefined,
): ActiveFieldDeclaration[] => {
  const values = useFormValues<FormInitialValues>();

  return findFieldDeclarations(fields, values);
};
